import { render } from "./NetworkSelection.vue?vue&type=template&id=452cdbe4&scoped=true"
import script from "./NetworkSelection.vue?vue&type=script&lang=js"
export * from "./NetworkSelection.vue?vue&type=script&lang=js"

import "./NetworkSelection.vue?vue&type=style&index=0&id=452cdbe4&lang=less&scoped=true"

import exportComponent from "/mnt/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-452cdbe4"]])

export default __exports__